import React from 'react'
import { Tabs, Typography } from 'antd'
import BlacklistPage from '../Blacklist'
import ProtectionConfig from '../../components/ProtectionConfig'

const { Paragraph } = Typography

/**
 * 风控中心：黑名单 / HR 花名册（复用既有页面实现）+ 保护期配置
 * 新客校验人工审核统一在「审核中心」完成（拍板4）
 */
const RiskControlPage: React.FC = () => {
  return (
    <>
      <Paragraph type="secondary" style={{ marginBottom: 12, fontSize: 13 }}>
        黑名单与 HR 花名册用于审批与发奖前的自动比对；保护期配置影响新归属线索的快照保护天数。
      </Paragraph>
      <Tabs
        items={[
          { key: 'blacklist', label: '黑名单 / HR 花名册', children: <BlacklistPage /> },
          { key: 'protection', label: '保护期配置', children: <ProtectionConfig /> },
        ]}
      />
    </>
  )
}

export default RiskControlPage
